// extracted by mini-css-extract-plugin
export default {"container":"home_container__kcAMo","sectionlist":"home_sectionlist__Z3ctm","button":"home_button__hcPPo","toparrow":"home_toparrow__jXiOu"};